import React, { useState } from 'react';
import { Building2, Map, FileText, Scale, AlertCircle, TrendingUp, TrendingDown, Minus, MapPin, PlusCircle } from 'lucide-react';
import { LegalFilingsModal } from './LegalFilingsModal';
export function DetailsTab() {
  const [legalTab, setLegalTab] = useState('ALL');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFilingIndex, setSelectedFilingIndex] = useState(0);
  const handleOpenModal = (index: number) => {
    setSelectedFilingIndex(index);
    setIsModalOpen(true);
  };
  return <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-744" data-mp="3td70cvcb4qx2">
      {/* Company Details - 3 Column Layout */}
      <div className="grid grid-cols-3 gap-6" data-id="element-745" data-mp="6x2tdekkw2vd">
        {/* Registration */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-746" data-mp="6z5sqp7mf8cr">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-747" data-mp="35n308xybv9at">Registration</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs" data-id="element-748" data-mp="3al4qq3y32awb">
            <div data-id="element-749" data-mp="2r6amkfrw26if">
              <p className="font-semibold text-gray-900" data-id="element-750" data-mp="2r4prmp1nwlk1">SOS State</p>
              <p className="text-gray-600" data-id="element-751" data-mp="2m6xu9fi9078g">PA</p>
            </div>
            <div data-id="element-752" data-mp="2m8r413o5r7ko">
              <p className="font-semibold text-gray-900" data-id="element-753" data-mp="2hfy0uk8c87ap">Founded Date</p>
              <p className="text-gray-600" data-id="element-754" data-mp="2hdv1h9lap1tb">1949</p>
            </div>
            <div data-id="element-755" data-mp="2ddb2e0h5vo4j">
              <p className="font-semibold text-gray-900" data-id="element-756" data-mp="2ddulhkijsik5">SOS Number</p>
              <p className="text-gray-600" data-id="element-757" data-mp="28gay9v3vgvg2">8675309</p>
            </div>
            <div data-id="element-758" data-mp="23gg85trx89w2">
              <p className="font-semibold text-gray-900" data-id="element-759" data-mp="23fwzz4s2ozv8">Type</p>
              <p className="text-gray-600" data-id="element-760" data-mp="23ij4evjo2z98">S-Corporation</p>
            </div>
            <div data-id="element-761" data-mp="1yhdd925nnk1t">
              <p className="font-semibold text-gray-900" data-id="element-762" data-mp="1yiwsqqjhlr2j">TIN Number</p>
              <p className="text-gray-600" data-id="element-763" data-mp="1uh2zv4fj9rcx">23-1984726</p>
            </div>
            <div data-id="element-764" data-mp="3su39hqjhx5cd">
              <p className="font-semibold text-gray-900" data-id="element-765" data-mp="3sul28d6y91fj">DBAs</p>
              <p className="text-gray-600" data-id="element-766" data-mp="3ot9k0sqenihd">DUNDER MIFFLIN</p>
            </div>
            <div data-id="element-767" data-mp="1m6udg63s0dzt">
              <p className="font-semibold text-gray-900" data-id="element-768" data-mp="1m6ceh1pqblo7">Domestic / Foreign</p>
              <p className="text-gray-600" data-id="element-769" data-mp="1qxknhwn5d50u">Domestic</p>
            </div>
            <div data-id="element-770" data-mp="1qznk4zit1wej">
              <p className="font-semibold text-gray-900" data-id="element-771" data-mp="1d6625j5rorqm">Entity Type</p>
              <p className="text-gray-600" data-id="element-772" data-mp="1d80lwu5aydt4">Private Subsidiary</p>
            </div>
          </div>
        </div>

        {/* Information */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-773" data-mp="24xlmf6juq2do">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-774" data-mp="29wge6xzsr19x">Information</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs mb-3" data-id="element-775" data-mp="29uccmmpdeect">
            <div data-id="element-776" data-mp="1vvvve1tvt5gf">
              <p className="font-semibold text-gray-900" data-id="element-777" data-mp="1vwe25se6722l">SIC</p>
              <p className="text-gray-600" data-id="element-778" data-mp="20up99vd2yyh4">5112 - PAPER & OFFICE SUPPLIES</p>
            </div>
            <div data-id="element-779" data-mp="kh8t86ng47aj">
              <p className="font-semibold text-gray-900" data-id="element-780" data-mp="kgpeszx08119">Ticker</p>
              <p className="text-gray-600" data-id="element-781" data-mp="ph4pfjpwiufj">--</p>
            </div>
            <div data-id="element-782" data-mp="pe8pxqyenxoz">
              <p className="font-semibold text-gray-900" data-id="element-783" data-mp="gzb2u03b5vkp">NAICS</p>
              <p className="text-gray-600" data-id="element-784" data-mp="gxroif17pulk">
                424120 - STATIONERY AND OFFICE SUPPLIES
              </p>
            </div>
            <div data-id="element-785" data-mp="qxifi6qkdrgw">
              <p className="font-semibold text-gray-900" data-id="element-786" data-mp="qy0nu1qi3w56">Approximate Revenue</p>
              <p className="text-gray-600" data-id="element-787" data-mp="lyxgubqynfuk">~$48 Million</p>
            </div>
          </div>
          <div className="text-xs" data-id="element-788" data-mp="3ueh6z1wc4i5e">
            <p className="font-semibold text-gray-900 mb-0.5" data-id="element-789" data-mp="3ufirdwz8qgzs">Description</p>
            <p className="text-gray-600 line-clamp-3" data-id="element-790" data-mp="3pfwfprz298t3">
              Dunder Mifflin Inc. provides paper and office supplies to small
              businesses. With a mid-size market focus, we pride ourselves on
              customer service that big box stores can't match. "Limitless paper
              in a paperless world."
            </p>
            <button className="text-indigo-600 hover:text-indigo-700 font-medium mt-1" data-id="element-791" data-mp="3bmet1yb2vfyu">
              More
            </button>
          </div>
        </div>

        {/* Location */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 flex flex-col" data-id="element-792" data-mp="29yt2b0sv3o1r">
          <div className="flex justify-between items-start mb-2" data-id="element-793" data-mp="2exe4v6vl6jtd">
            <h3 className="text-sm font-bold text-gray-900" data-id="element-794" data-mp="2iyg2jj9uunt8">Location</h3>
            <Map className="w-4 h-4 text-indigo-600" data-id="element-795" data-mp="2iwd6ahi3zyg2" />
          </div>
          <div className="text-xs text-gray-600 mb-2" data-id="element-796" data-mp="2nqhcgyjjw2g3">
            <p data-id="element-797" data-mp="2soiwpmspq7t5">1725 SLOUGH AVENUE, SUITE 200</p>
            <p data-id="element-798" data-mp="2snrc170nluhn">SCRANTON, PA 18503, US</p>
          </div>
          <div className="flex-1 bg-gray-100 rounded-lg border border-gray-200 overflow-hidden max-h-[150px]" data-id="element-799" data-mp="2xmkocw47ffg8">
            <img src="https://cdn.magicpatterns.com/uploads/wvsUfBV1167d45Ehi9LHfe/scrantonbusinesspark2.jpg" alt="Dunder Mifflin Office - Scranton Business Park" className="w-full h-full object-contain bg-gray-50" data-id="element-800" data-mp="32n8g5k09c0bi" />
          </div>
        </div>
      </div>

      {/* Legal Filings */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-801" data-mp="1cbu2ih6vhzzn">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50/50" data-id="element-802" data-mp="14rjiulp6ditx">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-803" data-mp="zxf8rtkm4uom">Legal Filings (3)</h3>
          <div className="flex bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden text-sm font-medium" data-id="element-804" data-mp="v0yl10hbsic2">
            {['ALL', 'LAWSUITS', 'LIENS', 'UCC', 'BANKRUPTCY'].map(tab => <button key={tab} onClick={() => setLegalTab(tab)} className={`px-4 py-2 border-r border-gray-200 last:border-r-0 flex items-center gap-2 transition-colors ${legalTab === tab ? 'bg-gray-100 text-gray-900' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'}`} data-id="element-805" data-mp="1nokp09ugtozg">
                {tab === 'LAWSUITS' && <Scale className="w-4 h-4" data-id="element-806" data-mp="39j1xgez9dql" />}
                {tab === 'LIENS' && <FileText className="w-4 h-4" data-id="element-807" data-mp="36wlera3znw8" />}
                {tab === 'UCC' && <Building2 className="w-4 h-4" data-id="element-808" data-mp="3udzbtgi4hq5e" />}
                {tab === 'BANKRUPTCY' && <AlertCircle className="w-4 h-4" data-id="element-809" data-mp="3vxr5ff36r2fs" />}
                {tab}
              </button>)}
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-810" data-mp="4obz0i8z4zw7">
          {(legalTab === 'ALL' || legalTab === 'LIENS') && <button onClick={() => handleOpenModal(0)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-811" data-mp="3mydxwrymgnxp">
              <div className="flex items-center gap-4" data-id="element-812" data-mp="3d457qax2d72p">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-813" data-mp="3hxzujn7yu260">
                  <FileText className="w-5 h-5 text-gray-500" data-id="element-814" data-mp="339mykq8vojbi" />
                </div>
                <div className="text-left" data-id="element-815" data-mp="3886lasvapz4x">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-816" data-mp="384shrhawbjvw">
                    <h4 className="font-bold text-gray-900" data-id="element-817" data-mp="2u7vufptzkkjr">
                      LACKAWANNA COUNTY RECORDER
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-green-500" title="Released" data-id="element-818" data-mp="2z89r6bq5082h"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-819" data-mp="2anoktu9zdm3s">
                    STATE TAX LIEN • RELEASED
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-820" data-mp="2kiouinrv3a8p">
                <p className="font-medium text-gray-900" data-id="element-821" data-mp="2km4d40kqv1ev">4/25/2016</p>
                <p className="text-sm text-gray-500" data-id="element-822" data-mp="2yhybhpnw68dq">$1,118</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'UCC') && <button onClick={() => handleOpenModal(1)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-823" data-mp="389ly9d9i718v">
              <div className="flex items-center gap-4" data-id="element-824" data-mp="3h9hallesp2ah">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-825" data-mp="3h7xz08433ff1">
                  <Building2 className="w-5 h-5 text-gray-500" data-id="element-826" data-mp="3c936gegbechq" />
                </div>
                <div className="text-left" data-id="element-827" data-mp="nk3dn7ymscae">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-828" data-mp="sganhbu5e7xm">
                    <h4 className="font-bold text-gray-900" data-id="element-829" data-mp="wins1wx5rzst">
                      DE LAGE LANDEN FINANCIAL SERVICES
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-blue-500" title="Active" data-id="element-830" data-mp="11gpbiiyhy14t"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-831" data-mp="8sl3vrwd7dzh">
                    UCC FILING • EQUIPMENT LEASE (COPIERS)
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-832" data-mp="iiw5h7sktb37">
                <p className="font-medium text-gray-900" data-id="element-833" data-mp="ijxru8f1lk08">2/14/2023</p>
                <p className="text-sm text-gray-500" data-id="element-834" data-mp="3h966mqyelau5">Active</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'LAWSUITS') && <button onClick={() => handleOpenModal(2)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-835" data-mp="3m5mudk1oxn6p">
              <div className="flex items-center gap-4" data-id="element-836" data-mp="39nkeiicbexqz">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-837" data-mp="34p91jyqq474j">
                  <Scale className="w-5 h-5 text-gray-500" data-id="element-838" data-mp="30o5plnbsqv8l" />
                </div>
                <div className="text-left" data-id="element-839" data-mp="2vqnogj40tkb5">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-840" data-mp="2vrfab27tg3o8">
                    <h4 className="font-bold text-gray-900" data-id="element-841" data-mp="2qy432zz3dkvs">
                      LEASE DISPUTE LAWSUIT
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-green-500" title="Settled" data-id="element-842" data-mp="2lxgbac31h00i"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-843" data-mp="2cybcr5rh96oc">
                    CIVIL LAWSUIT • LEASE DISPUTE • SETTLED
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-844" data-mp="3om9a65ada8tp">
                <p className="font-medium text-gray-900" data-id="element-845" data-mp="3ol7m90895ruk">6/10/2019</p>
                <p className="text-sm text-gray-500" data-id="element-846" data-mp="3jnxxznwlnm8b">Settled</p>
              </div>
            </button>}
        </div>
      </div>

      {/* News */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-847" data-mp="3tdr100ioet0y">
        <div className="p-5 border-b border-gray-200" data-id="element-848" data-mp="35o6e56jejbme">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-849" data-mp="35oy86cxcp1ak">News</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-850" data-mp="30qwpht3u73zm">
          <table className="w-full text-sm text-left" data-id="element-851" data-mp="3fmvx72n1b248">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-852" data-mp="3fogtawozyt47">
              <tr data-id="element-853" data-mp="3amred5ynlvau">
                <th className="px-5 py-3 font-medium" data-id="element-854" data-mp="3am7yrvwh7izz">Date</th>
                <th className="px-5 py-3 font-medium" data-id="element-855" data-mp="uw55cflr8jr6">Title</th>
                <th className="px-5 py-3 font-medium" data-id="element-856" data-mp="uyhpmzezj67e">Sentiment</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-857" data-mp="xh2wb9pwgzme">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-858" data-mp="xgb8il2jo66o">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-859" data-mp="12gpbhopagpxu">
                  Mar 15, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-860" data-mp="ohpvf5fudjda">
                  Scranton Branch Reports Record Breaking Sales Quarter, Led by
                  Top Salesman Dwight Schrute
                </td>
                <td className="px-5 py-4" data-id="element-861" data-mp="1g8ciaiguxguv">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-862" data-mp="1l6e0z2adfe5t">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-863" data-mp="17d6877ak0cmj" />
                    Positive
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-864" data-mp="1z66m8i34p26e">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-865" data-mp="23x559pfi4edc">
                  Feb 28, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-866" data-mp="2dtf5852oibsx">
                  Regional Manager Hosts Unsanctioned "Office Olympics" — HR
                  Investigation Launched After Flonkerton Injury
                </td>
                <td className="px-5 py-4" data-id="element-867" data-mp="24qw53sqa2dad">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-200" data-id="element-868" data-mp="1ztcnqjya9ke7">
                    <TrendingDown className="w-3.5 h-3.5" data-id="element-869" data-mp="1uvknn2nhiryx" />
                    Negative
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-870" data-mp="1m1g0oubh20oo">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-871" data-mp="1lzlfrg07a8kl">
                  Jan 12, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-872" data-mp="1c3ic25ppa1vj">
                  Dunder Mifflin Expands Regional Operations
                </td>
                <td className="px-5 py-4" data-id="element-873" data-mp="175gw3tnkmioa">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-874" data-mp="x10fgy29oxjf">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-875" data-mp="121xwv8fgdnjv" />
                    Positive
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Affiliated Companies */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-876" data-mp="eb1yfsghru3n">
        <div className="p-5 border-b border-gray-200" data-id="element-877" data-mp="j8u2tlybp8oq">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-878" data-mp="j797hu46plpt">
            Affiliated Companies
          </h3>
        </div>
        <div className="overflow-x-auto" data-id="element-879" data-mp="sz6iazra6bo0">
          <table className="w-full text-sm text-left" data-id="element-880" data-mp="t08521hnsmlk">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-881" data-mp="3rp6nmepdta1c">
              <tr data-id="element-882" data-mp="3rn2khyzb4f24">
                <th className="px-5 py-3 font-medium" data-id="element-883" data-mp="ivr8vvbgxgc">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-884" data-mp="h19fqfcdlgh">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-885" data-mp="2279war2x0txp">Country</th>
                <th className="px-5 py-3 font-medium w-12" data-id="element-886" data-mp="1x8ylad0vwddw"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-887" data-mp="2bxupu03qf89r">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-888" data-mp="2bzfi1j2kqf4g">
                <td className="px-5 py-3 text-indigo-600" data-id="element-889" data-mp="276urqrivmk5o">ENERVATE INC.</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-890" data-mp="2ky9cb2sfmteu">Ultimate Parent</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-891" data-mp="2l0m2u4c9ac3i">US</td>
                <td className="px-5 py-3" data-id="element-892" data-mp="2gw5yi7iajcqe">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-893" data-mp="2gza8jlift2oz">
                    Monitored
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-894" data-mp="10jh53449z8xy">
                <td className="px-5 py-3 text-indigo-600" data-id="element-895" data-mp="vjuuz3jqu8td">SABRE CORPORATION</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-896" data-mp="vlxohxk3uk2u">Immediate Parent</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-897" data-mp="377q4jcuuyd54">US</td>
                <td className="px-5 py-3" data-id="element-898" data-mp="3c4zseo2lmgqu">
                  <PlusCircle className="w-5 h-5 text-indigo-500 cursor-pointer hover:text-indigo-700 transition-colors" data-id="element-899" data-mp="3c842g22qw6pf" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Branch Offices */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-900" data-mp="2og72b88nr345">
        <div className="p-5 border-b border-gray-200" data-id="element-901" data-mp="2tfti9pfvexgn">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-902" data-mp="2td6zetnj4vj4">Branch Offices</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-903" data-mp="2ekdkb9c66hez">
          <table className="w-full text-sm text-left" data-id="element-904" data-mp="2jgu8g3jdcvs2">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-905" data-mp="2jjgetzuix58p">
              <tr data-id="element-906" data-mp="crfkuunw0ql2">
                <th className="px-5 py-3 font-medium" data-id="element-907" data-mp="cotcwtx3492b">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-908" data-mp="hopk1212wgm3">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-909" data-mp="g8k624opskuv">Address</th>
                <th className="px-5 py-3 font-medium" data-id="element-910" data-mp="g6quqc35pcgj">Country</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-911" data-mp="bbtpzhcwtp9g">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-912" data-mp="6bp4te1246cw">
                <td className="px-5 py-3 text-gray-900" data-id="element-913" data-mp="29c0mu1ykgi8">
                  DUNDER MIFFLIN SCRANTON
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-914" data-mp="yzl2akyga2aq">
                  Headquarters / Branch
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-915" data-mp="u1jityx440yq">
                  1725 Slough Ave, Scranton, PA 18503
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-916" data-mp="p7f9j90djguh">US</td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-917" data-mp="l7etxl1jgzlu">
                <td className="px-5 py-3 text-gray-900" data-id="element-918" data-mp="1hq2oe6os1zn4">
                  DUNDER MIFFLIN AKRON
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-919" data-mp="1cyaze0l9s1z3">Branch Office</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-920" data-mp="2vmdxomj3ywlp">
                  400 Market St, Akron, OH 44308
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-921" data-mp="30lqh0xartljj">US</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && <LegalFilingsModal onClose={() => setIsModalOpen(false)} initialIndex={selectedFilingIndex} data-id="element-922" data-mp="39m55g5j17gr9" />}
    </div>;
}